import logo from '../sprites/logo.json'; 
import letterHash from '../sprites/letter-hash.json'; 
import letterC from '../sprites/letter-c.json'; 
import letterS from '../sprites/letter-s.json';
import letterV from '../sprites/letter-v.json';
import letterR from '../sprites/letter-r.json';
import circle from '../sprites/circle.json';
import eyeBlink from '../sprites/eye-blink.json';
import player1 from '../sprites/player1.json';
import player2 from '../sprites/player2.json';
import shapes from '../sprites/shapes.json';
import star from '../sprites/star.json';
import warp from '../sprites/warp.json';
import blocktypes from '../sprites/blocktypes.json';
import questionmark from '../sprites/questionmark.json';
import globe from '../sprites/globe.json';

export const SPRITES = {
  logo: logo,
  circle: circle,
  eye: eyeBlink,
  player1,
  player2,
  shapes,
  star,
  warp,
  blocktypes,
  questionmark,
  globe,
  letter: {
    '#': letterHash,
    c: letterC,
    s: letterS,
    v: letterV,
    r: letterR,
  }
}